import { useState } from "react";
import { Form, DrawerProps, Drawer } from "antd";
import { updateRecord } from "../../utils/slice";
import { validateFields } from "../../../../../config/Global";
import SVGIcon from "../../../../../utils/SVGIcon";
import Config from "../../../../../config/Config";
import CancelButton from "../../../../../components/Buttons/CancelButton";
import SaveButton from "../../../../../components/Buttons/SaveButton";
import FormComponent from "./FormComponent";
import { assignErrorToInput } from "../../../../../store/api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";

interface EditDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders an edit component for a drawer.
 *
 * @param {EditDrawerProps} props - The props for the EditComponent.
 * @param {string} props.titleName - The title name for the drawer.
 * @param {boolean} props.open - Whether the drawer is open or not.
 * @param {() => void} props.close - The function to close the drawer.
 * @param {...DrawerProps} props.rest - Additional props for the Drawer component.
 * @return {ReactElement} The rendered EditComponent.
 */
const EditComponent: React.FC<EditDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const details = useAppSelector(state => state.customerAccess.details);
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  const drawerClose = () => {
    close();
    // form.resetFields();
    // setDisabled(true)
  };

  //Validates the form fields and sets the disabled state accordingly.
  const validateForm = () => {
    validateFields(form, setDisabled);
  };

  /**
   * Handles the form submission by dispatching create record api with the provided data,
   * and closes the drawer on success or displays error messages on failure.
   */
  const handleSubmit = (data: any) => {
    // alert('updated success');
    delete data.company_id;
    delete data.short_code;
    delete data.access_code_count;
    delete data.category_id;
    delete data.special_flag;
    delete data.industry_id;
    setSaving(true);
    
    dispatch(updateRecord(details.id, data))
      .then(() => {
        drawerClose();
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      })
      .finally(() => setSaving(false));
  };
  
  return (
    <Drawer
      title={`Edit ${titleName}`}
      open={open}
      width={"70%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[
        <CancelButton key={2} onClick={drawerClose} />,
        <SaveButton
          key={1}
          form="editForm"
          disabled={disabled}
          loading={saving}
        />,
      ]}
      {...rest}
    >
        {/* form Component */}
      <FormComponent
        form={form}
        id="editForm"
        editValues={details}
        handleSubmit={handleSubmit}
        onValuesChange={validateForm}
      />
    </Drawer>
  );
};

export default EditComponent;
